<template>
  <!-- The Modal -->
  <div
    id="editModal"
    class="modal"

  >
    <div class="modal-dialog" :class="{'modal-xl': isLarge}">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
            title="Edit Settings"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="value">Parameter «<span class="text-muted">{{ settings.id }}</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="value"
                        rules="required"
                      >
                        <b-form-input
                        v-if="updatedSettings.id !== 'PRIVACY' && updatedSettings.id !== 'TERMS'"
                          id="value"
                          v-model="updatedSettings.value"
                          name="value"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                        />
                        <quill-editor
                            v-if="updatedSettings.id === 'PRIVACY' || updatedSettings.id === 'TERMS'"
                            id="value"
                            name="value"
                            v-model="updatedSettings.value"
                            :options="snowOption"
                        />


                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12" v-if="updatedSettings.id === 'PRIVACY' || updatedSettings.id === 'TERMS'">
                    <b-form-group>
                      <label for="value">Parameter «<span class="text-muted">{{ settings.id }}</span>»«<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="value_ar"
                          rules="required"
                      >
                        <quill-editor
                            id="value_ar"
                            name="value_ar"
                            v-model="updatedSettings.value_ar"
                            :options="snowOption"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea, BCardText,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { codeBasic } from './code'
import settingsService from '@/services/settingsService'
import { quillEditor } from 'vue-quill-editor'
import { codeSnow } from './editor/code'
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,

    quillEditor,
    BCardCode,
    BCardText,
  },
  props: ['settings', 'isLarge'],
  data() {
    return {
      updatedSettings: {
        id: '',
        value: '',
        value_ar: '',
      },
      codeBasic,
      snowOption: {
        theme: 'snow',
      },
    }
  },
  mounted() {
    this.$watch(() => this.settings, val => {
      /* Init Updated Object (Which will be sent To API) */
      this.updatedSettings = {
        id: val.id,
        value: val.value,
        value_ar: val.value_ar ?? '',
      }
    })
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          settingsService.put(this.updatedSettings).then(response => {
            this.$emit('refresh', 'true')
            $('#editModal').modal('hide')
            if (response && response.status === 200) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: 'Parameter Is Updated Successfully !',
                },
              })
            }
            this.loading = false
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label{
  font-weight: bold;
}
@import '@core/scss/vue/libs/quill.scss';

</style>
